import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Button from '../Button';

function Dropdown({
    label, children, align, className, icon, disabled,
})
{
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className="tw-relative tw-block">
            <Button
                onClick={() => setIsOpen(!isOpen)}
                className={className}
                disabled={disabled}
                icon={icon}
                type="primary"
                iconMargin="tw-mx-2"
                margin="tw-mt-0"
                padding="tw-pt-2 tw-pb-1.5 tw-px-2"
            >
                {label}
            </Button>
            <div className={`tw-z-[81] tw-absolute tw-h-0 tw-w-0 tw-border-l-[0.75rem] tw-border-r-[0.75rem] tw-border-b-[0.75rem] tw-left-1/2 translate-x-[-0.32rem] tw-border-b-white dark:tw-border-b-neutral-800 tw-border-r-transparent tw-border-l-transparent tw-border-solid ${isOpen ? 'tw-block' : 'tw-hidden'}`}></div>
            <div className={`tw-absolute dark:tw-bg-neutral-800 tw-bg-white tw-shadow-[rgba(151,141,121,0.7)_0px_30px_90px] tw-w-full tw-mt-3 tw-rounded tw-z-[80] tw-top-full ${isOpen ? 'tw-block' : 'tw-hidden'} ${align === 'right' ? 'tw-left-0' : 'tw-right-0'}`}>
                {children}
            </div>
        </div>
    );
}

Dropdown.defaultProps = {
    disabled: false,
};
Dropdown.propTypes = {
    align: PropTypes.oneOf(['left', 'right']),
    label: PropTypes.string.isRequired,
    className: PropTypes.string,
    children: PropTypes.node.isRequired,
    icon: PropTypes.object,
    disabled: PropTypes.bool,
};

export default Dropdown;
